// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** PassbookCheque Update Start ************************/
export const passbookChequeUpdateDetails = (updatePassbookChequeData: any) => {
	const data = {
		PassbookChequeDetailsToken: updatePassbookChequeData,
	};
	const url = `${API_URL}updatePassbookChequeDetails`;
	return makeApiCall(url, data);
};
/** ***************** PassbookCheque Update End ************************/
